/**
 * crainePhaseAllowlists.js — client-side Craine case-knowledge phase allowlists.
 *
 * The client previously derived these from the full npc-phase-bible.json, which
 * pulled the whole bible (full-game perChapter overlays that name sealed canon)
 * into the demo bundle. The client only needs the chunk
 * ALLOWLISTS (arrays of chunk ids, no prose, no spoilers), so they live here and
 * the bible stays out of dist.
 *
 * SINGLE SOURCE OF TRUTH: app/src/content/knowledge/data/npc-phase-bible.json,
 * entries where characterId === 'elias-craine', knowledgeScope.craineCaseKnowledgeChunks.
 * This file, the server copy (app/functions/prompts/npcPhaseChunks.js), and the
 * bible are kept identical by the prompt-sync gate (npm run test:promptsync, C7/C9).
 */

// phaseId letter -> ordered chunk ids that phase may receive.
export const PHASE_CHUNK_IDS = {
  A: ['case_overview', 'suspect_composite', 'geographic_pattern', 'chip_context'],
  B: [
    'case_overview',
    'suspect_composite',
    'geographic_pattern',
    'chip_context',
    'hargrove_context',
    'thread_courier',
    'thread_donation',
    'thread_trial',
    'interview_plan',
  ],
  C: [
    'case_overview_phase_c',
    'suspect_composite',
    'geographic_pattern',
    'chip_context',
    'chip_compromised',
    'hargrove_context',
    'thread_courier',
    'thread_donation',
    'thread_trial',
    'interview_plan',
    'rena_victim',
    'fifth_at_risk',
  ],
  D: [
    'case_overview_phase_c',
    'suspect_composite',
    'geographic_pattern',
    'chip_context',
    'chip_compromised',
    'hargrove_context',
    'thread_courier',
    'thread_donation',
    'thread_trial',
    'interview_plan',
    'rena_victim',
    'fifth_at_risk',
  ],
};
